//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import { dcopy } from '~/utils/utils'
import { debounce } from '~/utils/v'

export default {
  name: 'VAnchor',
  props: {
    items: {
      type: Array,
      required: true
    },
    activeItem: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      scroll: {
        isAtTop: true,
        isScrollingDown: true,
        lastScrollPosition: 0,
        scrollThreshold: 100
      },
      anchor: {
        busy: true,
        sticky: false,
        items: [],
        hiddenItems: [],
        hiddenItemsIds: [],
        loading: true,
        activeItem: null,
        dropdown: false
      },
      interval: null
    }
  },
  watch: {
    items: {
      deep: true,
      handler () {
        this.setItems()
      }
    },
    'scroll.isScrollingDown' () {
      if (this.scroll.isScrollingDown) {
        this.setItems()
      }
    },
    '$route' () {
      this.anchor.dropdown = false
    },
    'anchor.activeSection' () {
      this.$emit('setActiveSection', this.anchor.activeSection)
    }
  },
  mounted () {
    this.anchor.loading = false
    this.anchor.activeItem = this.items[0].key
    this.setItems()
    window.addEventListener('scroll', this.onScroll)
    window.addEventListener('resize', this.setItems)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },
  computed: {
    ...mapState({
      breakpoint: state => state.breakpoint
    })
  },
  created () {
    this.anchor.items = dcopy(this.items)
  },
  methods: {
    handleScroll () {
      const currentScroll = window.scrollY
      this.scroll.isAtTop = currentScroll === 0

      if (this.breakpoint.isDesktopOrTablet) {
        return
      }

      const scrollDifference = Math.abs(currentScroll - this.scroll.lastScrollPosition)
      if (scrollDifference > this.scroll.scrollThreshold) {
        this.scroll.isScrollingDown = currentScroll > this.scroll.lastScrollPosition
        this.scroll.lastScrollPosition = currentScroll
      }
    },
    getItem (idx = 0) {
      return this.anchor.items[idx] || {}
    },
    close () {
      this.anchor.dropdown = false
    },
    checkSticky: debounce(function (e) {
      const stickyElement = this.$refs.vAnchor
      if (!stickyElement) {
        return
      }

      const rect = stickyElement.getBoundingClientRect()
      this.anchor.sticky = rect.top === 0
    }, 200),
    onScroll () {
      this.handleScroll()
      this.items.forEach((item) => {
        const section = document.getElementById(item.key)
        const rect = section?.getBoundingClientRect()

        if (rect) {
          if (rect.top <= window.innerHeight / 2 && rect.bottom >= 0) {
            this.anchor.activeItem = item.key
          }
        }
      })
      this.checkSticky()
    },
    scrollToSection (key) {
      const section = document.getElementById(key)
      const anchorHeight = this.$refs.vAnchor.offsetHeight

      if (section) {
        const offsetTop = section.getBoundingClientRect().top + window.pageYOffset - anchorHeight - 24
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        })
      }
    },
    setItems: debounce(function () {
      const vAnchorBody = this.$refs.vAnchorBody
      if (!vAnchorBody) {
        return
      }

      if (this.anchor.running) {
        this.anchor.cancelled = true
        return
      }

      this.anchor.running = true
      this.anchor.cancelled = false

      this.anchor.items = []
      this.anchor.hiddenItems = []
      this.anchor.hiddenItemsIds = []

      this.anchor.busy = true

      let totalWidth = 0
      const containerWidth = vAnchorBody.getBoundingClientRect().width
      let overflow = false

      if (containerWidth) {
        this.$nextTick().then(() => {
          const promises = this.items.map((item, idx) => {
            this.anchor.items.push(item)
            return this.$nextTick().then(() => {
              const itemEl = vAnchorBody.children[idx]
              const itemWidth = parseFloat(getComputedStyle(itemEl).width)

              if (this.anchor.cancelled) {
                throw new Error('Cancelled')
              }

              if (totalWidth + itemWidth <= containerWidth && !overflow) {
                totalWidth += itemWidth
              } else {
                overflow = true
                const lastItem = this.anchor.items.pop()
                this.anchor.hiddenItems.unshift(lastItem)
                this.anchor.hiddenItemsIds.push(lastItem.key)
              }
            })
          })

          Promise.all(promises)
            .then(() => {
              if (!this.anchor.cancelled) {
                setTimeout(() => {
                  this.anchor.busy = false
                }, 0)
              }
            })
            .catch((err) => {
              if (err.message !== 'Cancelled') {
                console.error(err)
              }
            })
            .finally(() => {
              this.anchor.running = false
              if (this.anchor.cancelled) {
                this.setItems()
              }
            })
        })
      }
    }, 200)
  }
}
